// extracted by mini-css-extract-plugin
export default {"card":"QueryCard_card__IUHd3"};